var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import classnames from 'classnames';
import { FormField } from '../FormField';
import { ColorPicker } from '../ColorPicker';
import { Card, CardSection } from '../Card';
class ColorPickerCardWrapper extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            focus: false,
        };
        this.handleColorPickerOnFocus = (e) => {
            this.setState({ focus: true });
            if (this.props.onFocus) {
                this.props.onFocus(e);
            }
        };
        this.handleColorPickerOnBlur = (e) => {
            this.setState({ focus: false });
            if (this.props.onBlur) {
                this.props.onBlur(e);
            }
        };
    }
    render() {
        const props = this.props;
        return (React.createElement(Card, { sharp: true, className: classnames('ColorPicker__CardWrapper', { 'ColorPicker__CardWrapper--disabled': props.disabled }, { 'ColorPicker__CardWrapper--focus': this.state.focus }) },
            React.createElement(CardSection, { className: "ColorPicker__CardSection" },
                React.createElement(ColorPicker, Object.assign({}, props, { onFocus: this.handleColorPickerOnFocus, onBlur: this.handleColorPickerOnBlur })))));
    }
}
ColorPickerCardWrapper.displayName = 'ColorPicker';
export const FormColorPicker = (_a) => {
    var props = __rest(_a, []);
    return React.createElement(FormField, Object.assign({ control: ColorPickerCardWrapper }, props));
};
//# sourceMappingURL=FormColorPicker.js.map